import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const BugReportManagement = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  
  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await axios.get('/api/bug-reports');
        setReports(response.data);
      } catch (error) {
        console.error('Error fetching bug reports:', error);
      } finally {
        setLoading(false);
      }
    };
    
    if (user?.role === 'admin') {
      fetchReports();
    }
  }, [user]);
  
  const updateStatus = async (reportId, newStatus) => {
    try {
      await axios.put(`/api/bug-reports/${reportId}`, { status: newStatus });
      setReports(reports.map(report => 
        report.id === reportId ? { ...report, status: newStatus } : report
      ));
    } catch (error) {
      console.error('Error updating bug report status:', error);
    }
  };
  
  if (user?.role !== 'admin') {
    return <div className="alert alert-danger">Access denied</div>;
  }
  
  if (loading) {
    return <div className="spinner-border text-primary" role="status"></div>;
  }
  
  return (
    <div className="container mt-4">
      <h2>Bug Reports</h2>
      
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Type</th>
            <th>Description</th>
            <th>User</th>
            <th>Page</th>
            <th>Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reports.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">No reports found</td>
            </tr>
          ) : (
            reports.map(report => (
              <tr key={report.id}>
                <td>
                  <span className={`badge bg-${
                    report.type === 'bug' ? 'danger' : 
                    report.type === 'feature' ? 'primary' : 'info'
                  }`}>
                    {report.type}
                  </span>
                </td>
                <td>{report.description}</td>
                <td>{report.userEmail || 'Anonymous'}</td>
                <td>{report.path}</td>
                <td>{new Date(report.timestamp).toLocaleString()}</td>
                <td>
                  <select 
                    className="form-select form-select-sm"
                    value={report.status}
                    onChange={(e) => updateStatus(report.id, e.target.value)}
                  >
                    <option value="New">New</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Resolved">Resolved</option>
                    <option value="Won't Fix">Won't Fix</option>
                  </select>
                </td>
                <td>
                  <button 
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => {
                      if (window.confirm('Are you sure you want to delete this report?')) {
                        axios.delete(`/api/bug-reports/${report.id}`)
                          .then(() => {
                            setReports(reports.filter(r => r.id !== report.id));
                          })
                          .catch(error => {
                            console.error('Error deleting report:', error);
                          });
                      }
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BugReportManagement;